import WarningIcon from 'assets/icons/alert-icon.svg';
import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import { SpinnerStyled } from 'components/common/LoadingScreen/ver2';
import SizeBox from 'components/common/SizeBox';
import {
  DESKTOP_MIN_WIDTH,
  FUNC_DEFAULT,
  MOBILE_MIN_WIDTH,
  TABLET_MAX_WIDTH,
} from 'constants';
import usePII from 'features/pii/hooks/usePII';
import usePIIAPI from 'features/pii/hooks/usePIIAPI';
import mask from 'helpers/mask';
import useAuth from 'hooks/useAuth';
import useCommonStore from 'hooks/useCommonStore';
import useCountdownToActionVer2 from 'hooks/useCountdownToActionVer2';
import useLang from 'hooks/useLang';
import { isEmpty } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import {
  cursorPointerMixin,
  displayFlexColCenterCenterMixin,
  displayFlexRowCenterCenterMixin,
  fontSize12Mixin,
  fontSize14Mixin,
  paragraph500Mixin,
  paragraph600Mixin,
  paragraph700Mixin,
  textBreakLineWordMixin,
} from 'styles';
import { numberUtils } from 'utils';

const FormPIIOTPVerificationPopup = ({
  isOpen,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
  modalData,
  modalOptions,
}) => {
  const { t } = useLang();
  const { currentUser, setLoading } = useCommonStore();
  const { logout } = useAuth();
  const { processVerifyOTPCodeRequest } = usePIIAPI();
  const { handleShowFormPIIVerificationSuccessfulModal } = usePII();

  const [isOTPVerifying, setOTPVerifying] = useState(false);
  const [isOTPVerificationIncorrect, setOTPVerificationIncorrect] =
    useState(false);
  const [isOTPVerificationBlocked, setOTPVerificationBlocked] = useState(false);

  const { mobile, email } = currentUser || {};

  const codeRef1 = useRef('');
  const codeRef2 = useRef('');
  const codeRef3 = useRef('');
  const codeRef4 = useRef('');
  const codeRef5 = useRef('');
  const codeRef6 = useRef('');

  const [code1, setCode1] = useState('');
  const [code2, setCode2] = useState('');
  const [code3, setCode3] = useState('');
  const [code4, setCode4] = useState('');
  const [code5, setCode5] = useState('');
  const [code6, setCode6] = useState('');

  const [codes, setCodes] = useState([
    { ref: codeRef1, code: code1, setCode: setCode1 },
    { ref: codeRef2, code: code2, setCode: setCode2 },
    { ref: codeRef3, code: code3, setCode: setCode3 },
    { ref: codeRef4, code: code4, setCode: setCode4 },
    { ref: codeRef5, code: code5, setCode: setCode5 },
    { ref: codeRef6, code: code6, setCode: setCode6 },
  ]);

  const [isResending, setResending] = useState(false);

  useEffect(() => {
    setLoading(false);
    if (codeRef1.current) {
      codeRef1.current?.focus();
    }
  }, []);

  const resetCode = () => {
    setCode1('');
    setCode2('');
    setCode3('');
    setCode4('');
    setCode5('');
    setCode6('');
  };

  const refreshCodes = () => {
    setCodes([
      { ref: codeRef1, code: code1, setCode: setCode1 },
      { ref: codeRef2, code: code2, setCode: setCode2 },
      { ref: codeRef3, code: code3, setCode: setCode3 },
      { ref: codeRef4, code: code4, setCode: setCode4 },
      { ref: codeRef5, code: code5, setCode: setCode5 },
      { ref: codeRef6, code: code6, setCode: setCode6 },
    ]);
  };
  useEffect(() => {
    refreshCodes();
  }, [code1, code2, code3, code4, code5, code6]);

  const handleResendTimeout = () => {
    setResending(false);
  };
  const { countdown } = useCountdownToActionVer2({
    countdownInit: 60,
    isRun: isResending,
    cb: handleResendTimeout,
    deps: [isResending],
  });

  const getOTPCode = (endCode) => {
    if (!endCode) return code1 + code2 + code3 + code4 + code5 + code6;
    return code1 + code2 + code3 + code4 + code5 + endCode;
  };

  const handleOnChange = (e, item, itemNext) => {
    let { value } = e.target || {};

    if (!numberUtils.isNumber(value)) return;

    if (value.length > 1) {
      value = value.slice(-1);
    }

    const { ref, setCode } = item;
    const { code: codeNext, ref: refNext } = itemNext || {};

    setCode(value);

    const element = ref?.current;
    const elementNext = refNext?.current;
    if (isEmpty(elementNext)) {
      element?.blur();
      setOTPVerifying(true);
      processVerifyOTPCodeRequest({
        otpCode: getOTPCode(value),
        callback: (data) => {
          setOTPVerifying(false);
          const { isVerified } = data || {};
          if (isVerified) {
            handleShowFormPIIVerificationSuccessfulModal();
          } else {
            setOTPVerificationIncorrect(true);
          }
        },
        errorCallback: (errorData) => {
          setOTPVerifying(false);
          resetCode();
          const { errorCode } = errorData || {};
          if (errorCode.includes('002')) {
            setOTPVerificationBlocked(true);
          }
        },
      });
    } else {
      if (!codeNext) {
        elementNext?.focus();
      }
    }
  };

  const handleOnFocus = (e, item) => {
    const { setCode } = item;
    setCode('');
  };

  const handleResendCTAOnClick = () => {
    setLoading(true);
    resetCode();
    setResending(true);
    setLoading(false);
    setOTPVerificationIncorrect(false);
  };
  const renderCTASection = () => {
    if (isResending)
      return (
        <CTAText
          dangerouslySetInnerHTML={{
            __html: t('popup_payto_otp_cta_2', {
              countdown,
            }),
          }}
        />
      );
    return (
      <CTASection>
        <CTAText>{t('popup_pii_otp_verification_cta')}</CTAText>
        <ResendButton onClick={handleResendCTAOnClick}>
          {t('button_resend')}
        </ResendButton>
      </CTASection>
    );
  };

  const renderFormOTPVerificationTitle = () => {
    return (
      <>
        <Title>{t('popup_pii_otp_verification_title')}</Title>
        <SizeBox height={10} />
      </>
    );
  };

  const renderFormOTPVerificationBodyContent = () => {
    if (isOTPVerifying)
      return (
        <>
          <SizeBox height={30} />
          <SpinnerStyled />
        </>
      );
    if (isOTPVerificationIncorrect)
      return (
        <>
          <SizeBox height={30} />
          <img src={NoticeIcon} width={75} height={60} />
          <SizeBox height={20} />
          <Desc
            dangerouslySetInnerHTML={{
              __html: t('popup_pii_otp_verification_incorrect'),
            }}
          />
          <SizeBox height={20} />
          <RetryButton onClick={handleResendCTAOnClick}>
            {t('button_retry')}
          </RetryButton>
        </>
      );
    if (isOTPVerificationBlocked)
      return (
        <>
          <SizeBox height={30} />
          <img src={WarningIcon} width={75} height={60} />
          <SizeBox height={20} />
          <Desc
            dangerouslySetInnerHTML={{
              __html: t('popup_pii_otp_verification_blocked'),
            }}
          />
          <SizeBox height={20} />
          <LogoutButton onClick={logout}>{t('button_logout')}</LogoutButton>
        </>
      );
    return (
      <>
        <Desc
          dangerouslySetInnerHTML={{
            __html: t('popup_pii_otp_verification_desc', {
              phone: mask.phone(mobile),
            }),
          }}
        />
        <SizeBox height={40} />
        <OTPCodeSection>
          {codes.map((item, index) => (
            <OTPCodeInput
              key={index}
              ref={item?.ref}
              type="tel"
              value={item?.code}
              placeholder=""
              inputMode="decimal"
              autoComplete="off"
              $isActive={item?.code}
              onChange={(e) =>
                handleOnChange(
                  e,
                  item,
                  index === codes.length - 1 ? null : codes[index + 1]
                )
              }
              onFocus={(e) => handleOnFocus(e, item)}
            />
          ))}
        </OTPCodeSection>
        <SizeBox height={40} />
        {renderCTASection()}
      </>
    );
  };

  return (
    <>
      <style>
        {zIndexModal
          ? `
            @media screen and (max-width: ${TABLET_MAX_WIDTH - 1}px) {
              .form-pii-otp-verification-modal {
                z-index: ${zIndexModal || 1101};
              }
            }
          `
          : ``}
        {isBackdropOverlap
          ? `
            .form-pii-otp-verification-modal-backdrop {
              z-index: ${zIndexBackdropOverlap || 1100};
              display: initial!important;
              height: calc(100vh - 70px);
              margin-top: 70px;
              background: #212121;
              opacity: 0.7!important;
            }
            @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
              .form-pii-otp-verification-modal-backdrop {
                background: #fff;
                opacity: 1!important;
              }
            }
          `
          : `
            .form-pii-otp-verification-modal-backdrop {
              display: initial!important;
              height: calc(100vh - 70px);
              margin-top: 70px;
              background: #212121;
              opacity: 0.7!important;
            }
            @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
              .form-pii-otp-verification-modal-backdrop {
                background: #fff;
                opacity: 1!important;
              }
            }
          `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={FUNC_DEFAULT}
        aria-labelledby="contained-modal-title-vcenter"
        className="form-pii-otp-verification-modal"
        backdropClassName="form-pii-otp-verification-modal-backdrop"
        centered
      >
        <ModalBody>
          <FormOTPVerification>
            {renderFormOTPVerificationTitle()}
            {renderFormOTPVerificationBodyContent()}
          </FormOTPVerification>
        </ModalBody>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  padding-left: 0 !important;
  padding-right: 0px !important;

  @media screen and (min-width: ${MOBILE_MIN_WIDTH}px) and (max-width: ${
  TABLET_MAX_WIDTH - 1
}px) {
    & .modal-dialog {
      position: absolute;
      margin: 0;
      top: 0px;
      height: 100dvh;
      width: 100%;
      max-width: 100%;
      align-items: end;
      transition: ease-out 0.3s !important;
      transform: none;

      & .modal-content {
        padding: 20px 16px;
        padding-bottom: 236px;
        border-radius: 0px;
        box-shadow: none;
        background: var(--ds-c-white);
        width: 100%;
        height: fit-content;
        margin-inline: auto;
        border: none;
        border-radius: 20px 20px 0 0;
      }
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    & .modal-dialog {
      transform: none;
      & .modal-content {
        border-radius: 0;
        box-shadow: none);
        background: var(--ds-c-white);
        border: none;
        width: 420px;
        margin-inline: auto;
        margin-top: 70px;
      }
    }
  }
`;
const ModalBody = styled(Modal.Body)`
  padding: 0;
  margin-bottom: 0px;
  background-color: #fff;
`;

const FormOTPVerification = styled.div`
  ${displayFlexColCenterCenterMixin};
`;
const Title = styled.p`
  ${paragraph600Mixin};
  font-size: 24px;
  line-height: 100%;
  text-align: center;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 40px;
  }
`;
const Desc = styled.p`
  ${paragraph500Mixin};
  text-align: center;
  ${textBreakLineWordMixin};
`;
const OTPCodeSection = styled.div`
  ${displayFlexRowCenterCenterMixin};
  gap: 12px;
`;
const OTPCodeInput = styled(Form.Control)`
  ${paragraph600Mixin};
  font-size: 32px;
  line-height: 100%;
  text-align: center;
  width: 44px;
  height: 44px;
  min-height: 44px;
  border: ${(props) =>
    props.$isActive
      ? '1px solid var(--c-primary)'
      : '1px solid var(--ds-c-grey-light)'};
  border-radius: 8px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: 60px;
    height: 60px;
    min-height: 60px;
  }

  &:focus {
    border: 1px solid var(--c-primary) !important;
    outline: none !important;
    box-shadow: none !important;
  }

  &[readonly] {
    background: #fff;
    border: none;
    color: var(--c-primary);
    cursor: not-allowed;
  }

  &::placeholder {
    ${paragraph600Mixin};
    font-size: 32px;
    line-height: 100%;
    text-transform: none;
  }
`;
const CTAText = styled.p`
  ${paragraph500Mixin};
  ${fontSize14Mixin};
  text-align: left;

  & span.resend-cta {
    color: #002ff1;
    text-decoration: underline;
    ${cursorPointerMixin};
  }
`;

const CTASection = styled.div`
  ${displayFlexRowCenterCenterMixin};
  gap: 4px;
`;
const ResendButton = styled.span`
  ${paragraph600Mixin};
  ${fontSize12Mixin};
  ${cursorPointerMixin};
  text-transform: uppercase;
  border-radius: 100px;
  border: 1px solid var(--ds-c-blue-hyperlink-default);
  color: var(--ds-c-blue-hyperlink-default);
  padding: 2.5px 16px;
`;

const RetryButton = styled.div`
  ${paragraph700Mixin};
  ${cursorPointerMixin};
  border-radius: 100px;
  color: var(--ds-c-blue-hyperlink-default);
  width: 100%;
  height: 50px;
  ${displayFlexRowCenterCenterMixin};
`;
const LogoutButton = styled.div`
  ${paragraph700Mixin};
  ${cursorPointerMixin};
  border-radius: 100px;
  color: var(--ds-c-red);
  width: 100%;
  height: 50px;
  ${displayFlexRowCenterCenterMixin};
`;

export default FormPIIOTPVerificationPopup;
